import React, { memo } from 'react';
import { SharedImgixAndSourceProps } from 'react-imgix';

import { StyledBackgroundImage } from './BackgroundImage.styles';

import { BackgroundImageProps } from './BackgroundImage.types';

export const BackgroundImage: React.FC<BackgroundImageProps> = ({
  src,
  imgixControlProps = {},
  htmlAttributes = {},
  children,
  style,
  className,
  ...props
}) => {
  const imgixProps = {
    auto: 'format',
    fm: src?.includes('.png') ? 'png' : 'jpg',
    ...imgixControlProps,
  };

  const htmlTagAttributes: SharedImgixAndSourceProps['htmlAttributes'] = {
    ...htmlAttributes,
    // TODO: fix the TS errors while moving to the new library
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    style,
  };

  return (
    <StyledBackgroundImage
      src={src}
      {...props}
      className={className}
      imgixParams={imgixProps}
      htmlAttributes={htmlTagAttributes}
    >
      {children}
    </StyledBackgroundImage>
  );
};
BackgroundImage.displayName = 'BackgroundImage';

export default memo(BackgroundImage);
